import {CartManager} from './Cart/CartManager';
import './AddToCartButton.scss';
import React from 'react';

export default function AddToCartButton({
  title, id, type, price, image, owned, noAbsolute
}) {
  const className = owned ? ' disabled' : '';

  return <>
    {noAbsolute ? null : <div style={{height: 70}}></div>}
    <div style={{position: noAbsolute ? 'relative' : 'absolute', bottom: noAbsolute ? null : 10, right: noAbsolute ? null : 10, paddingRight: noAbsolute ? null : 3}}>
      <div className="file-price">Price: ${price}</div>
      <div className={'cart-add-button btn btn-primary' + className} onClick={!owned ? (e) => {
        e.preventDefault();
        e.stopPropagation();
        CartManager.addProduct({
          productName: title,
          productId: id,
          productType: type,
          productPrice: price,
          image: image
        });
      } : null}>
        {owned ? 'Purchased' : <span>Add to Cart <span className="fa fa-plus"></span></span>}
      </div>
    </div>
  </>;
}
